import { api } from "../utils/AuthManager";
const GetAnomaliesChart = async (id, type) => {
  return api
    .get(`/api/anomalies_chart/${id}`, {
      params: {
        anomaly_type: type,
      },
    })

    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default GetAnomaliesChart;
